import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

interface Props {
    pdfUrl: string | null; // URL creada con Blob o URL externa
    onClose: () => void;   // función para cerrar modal
    title?: string;        // opcional: título del visor
}

const PDFViewerModal: React.FC<Props> = ({ pdfUrl, onClose, title }) => {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    if (!pdfUrl) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
            <div className="bg-white w-[90vw] h-[90vh] rounded-lg shadow-xl overflow-hidden flex flex-col">

                {/* HEADER */}
                <div className="flex justify-between items-center p-3 bg-gray-100 border-b">
                    <h2 className="text-lg font-semibold">
                        {title || "Vista previa del PDF"}
                    </h2>

                    <button
                        className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                        onClick={onClose}
                    >
                        Cerrar
                    </button>
                </div>

                {/* PDF VIEWER */}
                <div className="flex-1 overflow-hidden">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                    </Worker>
                </div>

            </div>
        </div>
    );
};

export default PDFViewerModal;
